<template>
  <div>
    <div class="flex justify-between py-6 border-b border-coolGray-200">
      <div class="flex items-center">
        <img
          v-if="code === 'google-classroom'"
          class="w-10 h-10 rounded-full"
          :src="icon"
        />
        <img
          v-else
          class="w-10 h-10 rounded-full"
          :src="`/static/integrations/${title}.png`"
        />
        <span class="font-semibold ml-4 center items-center">{{ title }}</span>
      </div>
      <div>
        <pl-spinner v-if="loading" />
        <template v-else>
          <button
            v-if="!integration_connected"
            class="px-10 py-2 w-40 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50"
            @click="selectIntegration"
          >
            Connect
          </button>
          <div v-else>
            <span class="text-xs mx-20">{{ profile.email }}</span>
            <button
              class="px-10 py-2 w-40 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50"
              @click="disconnectAccount()"
              :disabled="loading_to_disconnect"
            >
              Disconnect
            </button>
          </div>
        </template>
      </div>
    </div>

    <integrations-premium-feature-modal
      v-if="show_integrations_premium_feature_modal"
      @close="show_integrations_premium_feature_modal = false"
    />
    <integrations-upgrade-modal
      v-if="show_integrations_upgrade_modal"
      @close="show_integrations_upgrade_modal = false"
      :integration_name="integration.name"
      :integration_id="integration.id"
    />
    <disconnect-google-classroom-modal
      v-if="show_disconnect_classroom_modal"
      @close="show_disconnect_classroom_modal = false"
    />
    <profile-disconnect-integration-modal
      v-if="show_disconnect_integration_modal"
      :integration="integration || classroom_integration"
      @close="show_disconnect_integration_modal = false"
    />

    <pl-dialog
      v-if="show_select_school"
      :disableOutsideClick="true"
      :size="'md'"
      :title="'Select School'"
      @close="show_select_school = false"
    >
      <div class="px-7">
        <div class="my-7">
          You are a student in multiple schools in Parlay. Select the school
          where you also have the {{ integration.name }} account that you are
          trying to connect
        </div>
        <div
          v-for="school in integration_schools"
          :key="school.id"
          @click="selectSchool(school)"
          class="hover:underline hover:text-primary cursor-pointer"
        >
          {{ school.name }}
        </div>
      </div>
    </pl-dialog>
  </div>
</template>
<script lang="babel">
  import { mapGetters } from 'vuex';
  import integrationsPremiumFeatureModal from 'components/modals/integrationsPremiumFeatureModal';
  import integrationsUpgradeModal from 'components/modals/integrationsUpgradeModal';
  import disconnectGoogleClassroomModal from 'components/modals/disconnectGoogleClassroomModal';
  import profileDisconnectIntegrationModal from './profileDisconnectIntegrationModal';
  import adminServices from 'services/admin/adminServices';

  import googleClassroom from 'utils/googleClassroom';
  import urlConfigs from 'services/apiConfigs';
  import { EventBus } from 'utils/event-bus';


  export default {
    components: {
      integrationsPremiumFeatureModal,
      integrationsUpgradeModal,
      disconnectGoogleClassroomModal,
      profileDisconnectIntegrationModal
    },
    data() {
      return {
        connected:false,
        loading: false,
        show_integrations_premium_feature_modal: false,
        show_integrations_upgrade_modal: false,
        show_disconnect_classroom_modal:false,
        google_classroom_modal:false,
        loading_to_disconnect: false,
        show_disconnect_integration_modal: false,
        show_select_school:false,
        profile:{}
      };
    },
    props:{
      integration: {
        type: Object,
        default() {
          return {};
        },
      },
      title: {
        type: String,
        default: '',
      },
      code: {
        type: String,
        default: '',
      },
      icon:{
        type: String,
        default: '',
      },
      type:{
        type: String,
        default: '',
      },
      memberships:{
        type:Object,
        default:{}
      }
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getProfile'
      ]),
      integration_connected() {
        if(this.code === 'google-classroom'){
          if(
            this.getProfile.google_integration
          ) {
            return this.getProfile.google_integration.connected;
          }
          return false;
        } else if(this.integration.connected) {
          return true;
        }
        return false;
      },
      has_school_membership(){
        if (this.memberships.school_membership){
          return !this.memberships.school_membership.is_cancelled;
        }
        return false;
      }

    },
    methods:{
      selectIntegration(){
        if (this.getProfile.role === 'teacher'){
          this.connectIntegration();
        }
        else {
          this.studentConnectIntegration();
        }
      },
      async connectIntegration(){
          if(this.code  === 'google-classroom'){
            this.show_integrations_premium_feature_modal=false;
            this.show_integrations_upgrade_modal = false;
            this.connectOrUpdateGoogleClassroom();
          } else {
            if(!this.getProfile.is_paid || (this.getProfile.is_paid && !this.has_school_membership)){
              this.show_integrations_premium_feature_modal = true;
            }
            else {
              if(this.integration.school_connected){
                this.show_integrations_upgrade_modal=false;
                this.connectToIntegration();
              } else {
                this.show_integrations_upgrade_modal=true;
              }
            }
          }
      },
      studentConnectIntegration(){
        if(this.code  === 'google-classroom'){
          this.connectOrUpdateGoogleClassroom();
        }
        else {
          this.connectToIntegration();
        }
      },
      async connectOrUpdateGoogleClassroom() {
        if (!this.getProfile.google_integration.connected){
          const {code,email} = await googleClassroom.getCode();
          const redirect_uri = `${urlConfigs.uiURL}`;
          //just for connect
          await this.$store.dispatch('getClassroomToken', { code,redirect_uri,email});
        }
      },
      async connectToIntegration(){
        const {data : schools} = await adminServices.getUserSchoolIntegrations();
        if (schools.length > 1) {
          this.integration_schools = schools;
          this.show_select_school = true;
          return;
        }
        else {
          const integration_id = this.integration.integration_id;
          const redirect_uri =`${urlConfigs.uiURL}/profile/integrations`;
          this.$store.dispatch('getSsoMetadata', { redirect_uri, integration_id }).then((res) => {
            if (res.sso_login_url) {
              window.open(res.sso_login_url, '_self');
            }
          }).catch(() => {
            EventBus.emit('toast-msg','An error ocurred. Please try again later');
          });
        }
      },
      selectSchool(school){
        const integration = school.edlink_integrations.find(x => x.provider_id === this.integration.provider_id);
        if (integration && integration.id){
          const integration_id = integration.id;
          const redirect_uri =`${urlConfigs.uiURL}/profile/integrations`;
          this.$store.dispatch('getSsoMetadata', { redirect_uri, integration_id }).then((res) => {
            if (res.sso_login_url) {
              window.open(res.sso_login_url, '_self');
            }
          }).catch(() => {
            EventBus.emit('toast-msg','An error ocurred. Please try again later');
          });
        }
        else {
          this.show_select_school = false;
          this.show_integrations_upgrade_modal=true;
        }

      },
      disconnectAccount(){
        this.show_disconnect_integration_modal=true;
      },
    },
    async created() {
      if (this.integration.name === 'Google Classroom') {
        this.profile = this.getProfile.google_integration;
      } else {
        const user_integration = this.getProfile.edlink_integrations.find(
          (x) => x.id === this.integration.integration_id
        );
        if (user_integration) {
          if (user_integration.email && user_integration.name) {
            this.profile = {
              name: user_integration.name,
              email: user_integration.email,
            };
          } else {
            this.loading = true;
            const { data } = await adminServices.getSsoIntegrationProfile(
              this.integration.integration_id
            );
            this.loading = false;
            if (data) {
              this.profile = data;
            }
          }
        }
      }
    },
  };
</script>
<style scoped></style>



// WEBPACK FOOTER //
// profileIntegrationCard.vue?74727d91